import api from '../api/axios';
import { getApiErrorMessage } from './apiError';
import { showError } from './toast';
import { CANDIDATE_DOCUMENT_FIELDS } from './apiAssetUrl';

const FIELD_LABELS = {
  [CANDIDATE_DOCUMENT_FIELDS.resume]: 'resume',
  [CANDIDATE_DOCUMENT_FIELDS.ornnovaProfile]: 'Ornnova profile',
};

async function readJsonErrorFromBlob(blob) {
  try {
    const text = await blob.text();
    const parsed = JSON.parse(text);
    return parsed.message || parsed.msg || null;
  } catch {
    return null;
  }
}

function closePreviewTab(previewTab) {
  if (!previewTab || previewTab.closed) return;
  try {
    previewTab.close();
  } catch {
    // ignore cross-origin or already-closed tab errors
  }
}

function showDocumentFetchError(error, label) {
  const status = error.response?.status;
  if (status === 404) {
    showError(`The ${label} file was not found on the server.`);
    return;
  }
  if (status === 403) {
    showError('You do not have permission to view this document.');
    return;
  }
  showError(getApiErrorMessage(error, `Unable to open ${label}.`));
}

/**
 * Fetch a candidate PDF with auth and open it in a new browser tab.
 * Opens a blank tab synchronously (user gesture) to avoid popup blockers.
 */
export async function openCandidateDocument(candidateId, documentField) {
  if (!candidateId) {
    showError('Candidate is not loaded.');
    return;
  }

  const label = FIELD_LABELS[documentField] || 'document';

  const previewTab = window.open('', '_blank');
  if (!previewTab) {
    showError('Popup blocked. Allow popups for this site to view the PDF.');
    return;
  }

  try {
    const response = await api.get(`/api/candidates/${candidateId}/documents/${documentField}`, {
      responseType: 'blob',
    });

    const blob = response.data;
    if (blob?.type?.includes('application/json')) {
      const message = await readJsonErrorFromBlob(blob);
      closePreviewTab(previewTab);
      showError(message || `Unable to open ${label}.`);
      return;
    }

    const objectUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
    previewTab.location.href = objectUrl;

    previewTab.addEventListener('beforeunload', () => {
      URL.revokeObjectURL(objectUrl);
    });
    window.setTimeout(() => URL.revokeObjectURL(objectUrl), 120000);
  } catch (error) {
    closePreviewTab(previewTab);
    showDocumentFetchError(error, label);
  }
}
